<div class="d-flex flex-column flex-md-row h-100 position-relative overflow-hidden">

  <div class="text-section text-white d-flex flex-column justify-content-center p-4 flex-shrink-0">
    <h2 class="fw-bold">Dogs are 30% more likely to go missing during summer.</h2>
    <h4  class="fs-4">Longer days, open doors, and more distractions. <br>Make sure your pet is protected when it matters most.</h4>
    <div class="d-flex justify-content-center">
      <a 
        href="https://identiblog.zendesk.com/hc/en-us/articles/35046752644125-Ten-years-on-since-compulsory-microchipping-for-dogs"
        class="btn btn-lg btn-light fw-bold mt-4 rounded-pill button"
        target="_blank"
        rel="noopener noreferrer"
        >
        Find out more
      </a>
    </div>
  </div>

  <div class="image-section position-relative w-100">
    <img 
      src="assets/images/home/10-year-banner-image.webp"
      alt="10 year banner image"
      class="w-100 h-100 object-fit-cover"
      width="650"
      height="400"
    />
    
    <div class="gradient-overlay position-absolute top-0 start-0"></div>
    
    <div class="badge-overlay d-flex flex-column position-absolute bottom-0 end-0 m-3">
      <span class="position-relative">Based on pets marked missing across identi Group databases (Feb 2016-Feb 2026), comparing mid-winter vs mid-summer.</span>
    </div>
  </div>
</div>
